import React from "react";
import { ArrowUpRight } from "lucide-react";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const ServiceCard = ({ service, index, icon: Icon, cta }) => {
  const slug = slugify(service.name);
  return (
    <article data-testid={`service-card-${slug}`} className="service-card p-7 md:p-8 flex flex-col gap-5">
      <div className="flex items-start justify-between">
        <span className="w-12 h-12 flex items-center justify-center bg-brand-primary text-white">
          <Icon className="w-6 h-6" strokeWidth={2} />
        </span>
        <span className="font-display font-bold text-xs text-brand-muted">
          {String(index + 1).padStart(2, "0")}
        </span>
      </div>
      <div>
        <h3 className="font-display font-bold text-brand-primary text-xl md:text-[22px] leading-tight tracking-tight">
          {service.name}
        </h3>
        <p className="mt-3 text-sm md:text-[15px] text-brand-muted leading-relaxed">{service.desc}</p>
      </div>
      <a
        href="/#contact"
        data-testid={`service-cta-${slug}`}
        className="mt-auto inline-flex items-center gap-1.5 font-display font-bold text-sm text-brand-accent hover:gap-2.5 transition-all"
      >
        {cta}
        <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
      </a>
    </article>
  );
};
